import React from 'react';
import './index.css';
import BannerAnim, { Element } from 'rc-banner-anim';
import TweenOne from 'rc-tween-one';
import 'rc-banner-anim/assets/index.css';
import clsx from 'classnames';

const BgElement = Element.BgElement;

const Banner = () => {
  const bannerList = [
    {
      key: '1',
      textOne: '智能化检测设备制造领航者',
      textTwo: '个性化设备优质服务商',
      className: 'leader',
    },
    {
      key: '2',
      textOne: '掌握物联网核心技术',
      textTwo: '开创现代化检测新模式',
      className: 'innovation',
    },
    {
      key: '3',
      textOne: '智能制造我们在行动',
      textTwo: '成为一家适应潮流的创新型企业',
      className: 'action',
    },
  ];

  return (
    <BannerAnim prefixCls='banner-user' thumb={false} type='across' autoPlay>
      {bannerList?.map((v) => {
        return (
          <Element prefixCls='banner-user-elem' key={v.key}>
            <BgElement key='bg' className={`bg ${v.className}`} />
            <TweenOne
              className={clsx('banner-user-title')}
              animation={{ y: 30, opacity: 0, type: 'from' }}
            >
              {v.textOne}
            </TweenOne>
            <TweenOne
              className={clsx('banner-user-text')}
              animation={{ y: 30, opacity: 0, type: 'from', delay: 100 }}
            >
              {v.textTwo}
            </TweenOne>
          </Element>
        );
      })}
    </BannerAnim>
  );
};

export default Banner;
